import { HeroSection } from './HeroSection'
import { LicensesSection } from './LicensesSection'
import { ServicesSection } from './ServicesSection'
import styles from './Home.module.scss'

export const Home = () => {
  return (
    <div className={styles.container}>
      <HeroSection />
      <ServicesSection />
      <LicensesSection />
    </div>
  )
}